<ng-template #tabTemplate>
  <ng-content></ng-content>
</ng-template>
